import React,{useEffect, useState} from 'react';
import Styled from 'styled-components'
import CreditForm from './credit-card-form';
import SavedCardsContainer from './saved-cards-container';

const CreditCardsContainer = ({
  // selectedCardId, 
  selectCardHandler, 
  paymentHandler,
  selectedPlan,
  settings,
  skipSignUp,
  error,
  setError,
  paymentSuccessHandlerForSVTrial,
  ptlParent,
  parentDobYear,
  restrictionInfoStore,
  showDiscountChanges

  }) => {

    //to get saved and default card id
    useEffect(()=>{
      setError(null);
    }, [])
    const defaultCardId = () =>{
      let cards = settings.stripeCards;
      if(cards.length == 0){
        return null
      }else{
        var defaultCard = cards.filter(function(card){ return card.is_default; })[0];
        if(!defaultCard){
          defaultCard = cards[0];
        }
        return defaultCard.stripe_id;
      }
    }

    const [selectedCardId, selectedCardIdHandler] = useState(()=>defaultCardId());
    
    const savedCardsHandler = (data) => {
      setError(null);
      selectedCardIdHandler(data);
    }
  return (
    <PaymentContainer>
      <SavedCardsContainer
        settings={settings}
        selectedCardId={selectedCardId}
        savedCardsHandler={savedCardsHandler}
        addCardText={'+ Add New Card'}
      />

      <CreditForm
        paymentHandler={paymentHandler}
        settings={settings}
        selectedPlan={selectedPlan}
        selectedCardId={selectedCardId}
        error={error}
        setError={setError}
        skipSignUp={skipSignUp}
        paymentSuccessHandlerForSVTrial={paymentSuccessHandlerForSVTrial}
        ptlParent={ptlParent}
        parentDobYear={parentDobYear}
        restrictionInfoStore={restrictionInfoStore}
        showDiscountChanges={showDiscountChanges} 
        
      />
    </PaymentContainer>
  );
}

export const PaymentContainer = Styled.div`
  
`;

export default CreditCardsContainer;
